import {CSSProperties, Ref, forwardRef} from 'react';
import AspectRatioBox from './AspectRatioBox';
import ContentCardBody from './ContentCardBody';
import {DEFAULT_ASPECT_RATIO} from '../constant';
import {Page} from '../constant/page';
import {IContentCardCommonProps, IContentProps} from '../type';
import {routeTo} from '../util/PageRouter';

interface IProps extends IContentCardCommonProps {
  content: IContentProps;
  bgClassName?: string;
  bgStyle?: CSSProperties;
  aspectRatio?: number;
}

function ContentCardV4(
  {
    content,
    onClick,
    bgClassName,
    bgStyle,
    aspectRatio = DEFAULT_ASPECT_RATIO,
    ...rest
  }: IProps,
  ref: Ref<HTMLDivElement>
) {
  const {id, sid} = content;
  const _onClick = () => {
    onClick ? onClick(id, sid) : routeTo({page: Page.Content, id, sid});
  };

  return (
    <AspectRatioBox
      ref={ref}
      aspectRatio={aspectRatio}
      bgClassName={bgClassName}
      bgStyle={bgStyle}
    >
      <ContentCardBody content={content} onClick={_onClick} {...rest} />
    </AspectRatioBox>
  );
}

export default forwardRef(ContentCardV4);
